import { SxProps, Theme } from '@mui/material';

export const logoSx: SxProps<Theme> = {
  height: '18px',
  width: 'auto',
  cursor: 'pointer',
};
